import { Component, Inject } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { NewClientDto } from '../../../dto/NewClientDto';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatIcon } from '@angular/material/icon';
import { ModelDto, NewEquipmentDto } from '../../../dto/EquipmentDto';
import { ENVIRONMENT } from '../../../app.component';
import { MessageDialogBoxComponent } from '../../../components/message-dialog-box/message-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieManagerService } from '../../../services/TokenService/cookier-manager-service.service';

@Component({
  selector: 'app-new-equipment-view',
  standalone: true,
  imports: [
    MatGridListModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatButtonModule,
    RouterModule,
    RouterOutlet,
    RouterLink,
    MatTabsModule,
    MatIcon,
  ],
  templateUrl: './new-equipment-view.component.html',
  styleUrl: './new-equipment-view.component.scss'
})
export class NewEquipmentViewComponent {
  hidePassword = true;
  hidePasswordEvent(event: MouseEvent) {
    this.hidePassword = !this.hidePassword;
    event.stopPropagation();
  }

  hideConfirmPassword = true;
  hideConfirmPasswordEvent(event: MouseEvent) {
    this.hideConfirmPassword = !this.hideConfirmPassword;
    event.stopPropagation();
  }

  constructor(private http: HttpClient, @Inject(ENVIRONMENT) public envConfig: any, private router: Router, public dialog: MatDialog, private _snackBar: MatSnackBar, public cookieManagerService: CookieManagerService) { }

  equipmentModelFormControl = new FormControl('', [Validators.required]);
  equipmentSerialNumberFormControl = new FormControl('', [Validators.required]);
  equipmentSoftwareVersionFormControl = new FormControl('', [Validators.required]);
  equipmentUsernameFormControl = new FormControl('', [Validators.required]);
  equipmentPasswordFormControl = new FormControl('', [Validators.required]);
  equipmentConfirmPasswordFormControl = new FormControl('', [Validators.required]);

  newEquipmentActionButton() {
    const serviceRoute: string = '/equipments';

    const model = new ModelDto(
      this.equipmentModelFormControl.value ?? '',
    );

    const newEquipment = new NewEquipmentDto(
      model,
      this.equipmentSerialNumberFormControl.value ?? '',
      this.equipmentSoftwareVersionFormControl.value ?? '',
      this.equipmentUsernameFormControl.value ?? '',
      this.equipmentPasswordFormControl.value ?? '',
      this.equipmentConfirmPasswordFormControl.value ?? ''
    );

    const token = this.cookieManagerService.getAuthToken()
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', // Defina o tipo de conteúdo do cabeçalho
      'Authorization': `Bearer ${token}` // Adicione um cabeçalho de autorização se necessário
    });

    this.http.post<string>(
      `${this.envConfig.HaseCloudCoreEndpoint}${serviceRoute}`,
      newEquipment,
      { headers, observe: 'response' }
    ).subscribe({
      next: (response) => {
        this._snackBar.open("Equipamento cadastrado com sucesso", "Fechar", { duration: 5000 });
        this.router.navigate(['/equipments/list'])
      },
      error: (error) => {
        this.dialog.open(MessageDialogBoxComponent, {
          data: {
            httpResponseBase: error,
          }
        });
      }
    });
  }
}